import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
    planCreateRequest: ["plan"],
    planCreateSuccess: ["plan"],
    planCreateFailure: ["error"],

    planUpdateRequest: ["planId", "plan"],
    planUpdateSuccess: ["plan"],
    planUpdateFailure: ["error"],

    planAddWatchersRequest: ["watchers"],
    planAddWatchersSuccess: ["watcherContent"],
    planAddWatchersFailure: ["error"],

    planRemoveWatcherRequest: ["watcherId"],
    planRemoveWatcherSuccess: [],
    planRemoveWatcherFailure: ["error"],

    planAllWatchersRequest: ["planId"],
    planAllWatchersSuccess: ["watchers"],
    planAllWatchersFailure: ["error"],
});

export const PlanTypes = Types;
export default Creators;
